/* @flow */

import {
  createReducer,
  setRequestResult,
  setFetchingState,
  unsetFetchingState,
} from 'src/shared/core/util/reducerUtils';
import * as types from 'src/shared/domain/user/action/userActionTypes';

const initialState = {
  result: [],
  isFetching: false,
};

export default createReducer(initialState, {
  [types.FETCH_USERS_REQUEST]: setFetchingState,
  [types.FETCH_USERS_SUCCESS]: setRequestResult,
  [types.FETCH_USERS_FAILURE]: unsetFetchingState,
});
